import React, { useRef, useState, createContext } from 'react';
import { useSelector } from 'react-redux';
import GBHeader from './GBHeader';
import Tools from '../../components/VSidebar/VSidebar';
import ColorPicker from '../../components/ColorPicker/ColorPicker';
import Workplace from '../../components/Workspace/Workplace';
import { DndProvider } from 'react-dnd';
import HTML5Backend from 'react-dnd-html5-backend';
import FilterPanel from '../../components/VImage/panels/FilterPanel';
import AdjustPanel from '../../components/VImage/panels/AdjustPanel';
import FontFamilyPanel from '../../components/FontFamilyPanel/FontFamilyPanel';
import './GraphicBuilder.css';
import { useTranslation } from 'react-i18next';
import VMoveable from '../../components/VMoveable/VMoveable';
import Joyride from 'react-joyride';

export const DesignContext = createContext();

const GraphicBuilder = (props) => {
  const sidePanel = useSelector(state => state.design.sidePanel);
  const showFilterPanel = useSelector(state => state.design.showFilterPanel);
  const activePageRef = useRef(0);
  const activeTrimRef = useRef({});
  const activeVolumeRef = useRef();
  const [designLoaded, setDesignLoaded] = useState(false);
  const { t } = useTranslation();

  // eslint-disable-next-line react/prop-types
  const ExtraSidebar = ({ panel }) => {
    switch (panel) {
      case 'colorPicker':
        return <ColorPicker />;
      case 'fontFamily':
        return <FontFamilyPanel />;
      default:
        return null;
    }
  };

  const steps = [
    {
      target: 'body',
      placement: 'center',
      styles: {
        options: {
          // backgroundColor: 'var(--clrBack)',
          padding: '3rem 3rem 2rem',
          borderRadius: '13px',
          border: '2px solid var(--clrHeader)',
          width: 'auto',
        },
      },
      title: t('contents:usageAttentionTitle'),
      content: (
        <div style={{ lineHeight: 2 }}>
          <div style={{ textAlign: 'justify', lineHeight: '2' }}>
            {t('contents:usageAttentionLine1')}
            <br />
            {t('contents:usageAttentionLine2')}
            <br />
            {t('contents:usageAttentionLine3')}
            {/* <Button
              className="vButton colorPrimary"
              content={t('gotIt')}
              onClick={() => setActiveDim(false)}
            /> */}
          </div>
        </div>
      ),
    },
    {
      target: '.designName',
      title: t('contents:tourDesignName'),
      content: t('contents:tourDesignNameContent'),
    },
    {
      target: '.downloadBtn',
      title: t('contents:tourDownload'),
      content: t('contents:tourDownloadContent'),
    },
    {
      target: '.headerBtn.back',
      title: t('contents:tourBack'),
      content: t('contents:tourBackContent'),
    },
    {
      target: '.saving-state',
      title: t('contents:tourStatus'),
      content: t('contents:tourStatusContent'),
    },
    {
      target: '.undoRedoBox',
      title: t('contents:tourUndoRedo'),
      content: t('contents:tourUndoRedoContent'),
    },
    {
      target: '#GBTools .menu',
      placement: 'right',
      title: t('contents:tourResources'),
      content: t('contents:tourResourcesContent'),
    },
    {
      target: '.searchBox',
      title: t('contents:tourSearch'),
      content: t('contents:tourSearchContent'),
    },
    {
      target: '.zoomTool',
      title: t('contents:tourZoom'),
      content: t('contents:tourZoomContent'),
    },
  ];

  return (
    <section id="GBEditor">
      {props.mode !== 'export' && (
        <Joyride
          continuous={true}
          run={true}
          scrollToFirstStep={true}
          showProgress={true}
          showSkipButton={true}
          steps={steps}
          locale={{
            back: t('back'),
            close: t('close'),
            last: t('last'),
            next: t('next'),
            skip: t('tourSkip'),
          }}
          styles={{
            options: {
              zIndex: 1000,
              primaryColor: '#525252',
              textColor: '#000',
            },
          }}
        />
      )}
      <GBHeader mode={props.mode} getExport={designLoaded} />
      <section className="gb-content">
        <DndProvider backend={HTML5Backend}>
          <div className="container">
            <DesignContext.Provider value={{ activePageRef, activeTrimRef, activeVolumeRef }}>
              {props.mode !== 'export' && <Tools />}
              {props.mode !== 'export' && <ExtraSidebar panel={sidePanel} />}
              {showFilterPanel === 'filter' && <FilterPanel />}
              {showFilterPanel === 'adjust' && <AdjustPanel />}
              <section>
                <VMoveable />
                <Workplace mode={props.mode} isLoaded={setDesignLoaded}/>
              </section>
            </DesignContext.Provider>
          </div>
        </DndProvider>
      </section>
    </section>
  );
};

export default GraphicBuilder;
